import React, { useState } from 'react'
import * as R from 'ramda'

import CustomFieldSelector from 'components/CustomFieldSelector'
import useAxios, { mutate } from 'hooks/useAxios'
import useSaveUserActivityLog, { ACTION_NAME } from 'hooks/useSaveUserActivityLog'
import { toast } from 'libs/toast'

export default function IntercomTicketCustomFieldSelector({
  surveyToken,
  surveyId,
  options,
  integrationSetting,
  disabled,
  fieldKey,
  name,
  description,
  isSyncing,
}) {
  const [isError, setIsError] = useState(false)
  const { fetch: updateSurveyIntegrationSetting, loading } = useAxios({
    url: `/survey/survey-integration-setting/by-survey/${surveyToken}/additional-option/`,
    method: 'patch',
    skip: true,
  })

  const saveUserActivityLog = useSaveUserActivityLog()

  function handleChange(value) {
    const data = {
      name: 'push_ticket_custom_field',
      integration_type: 'intercom',
      option_name: fieldKey,
      option_value: value,
    }

    const logRequestBody = {
      integration: 'push_ticket_custom_field',
      mapping_field: fieldKey,
      mapping_value: value,
    }

    updateSurveyIntegrationSetting({ data })
      .then((response) => {
        mutate(`survey/${surveyToken}/survey-integration-setting/?integration_type=intercom`)
        setIsError(false)
        saveUserActivityLog({
          action: ACTION_NAME.connected_intercom,
          target: `sur_${surveyId}`,
          statusCode: response.status,
          requestBody: logRequestBody,
        })
        toast.success('Settings updated.')
      })
      .catch((error) => {
        setIsError(true)
        saveUserActivityLog({
          action: ACTION_NAME.connected_intercom,
          target: `sur_${surveyId}`,
          requestBody: logRequestBody,
          errorResponseBody: logRequestBody,
          statusCode: error.response.status,
        })
        toast.error(
          'Oops! Something went wrong. Please try again or contact Simplesat support for help.'
        )
      })
  }

  function getDefaultValue() {
    if (disabled) {
      return null
    } else {
      return R.path(['additional_option', fieldKey], integrationSetting) || null
    }
  }

  return (
    <CustomFieldSelector
      name={name}
      description={description}
      options={options}
      disabled={disabled}
      isError={isError}
      defaultValue={getDefaultValue()}
      onChange={handleChange}
      loading={loading}
      dropdownLoading={isSyncing}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomInAppPublish/UpdateTicketCustomFieldIntegration/IntercomTicketCustomFieldSelector.js